var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticClass:"up-arrow",attrs:{"height":"12","viewBox":"0 0 12 12","width":"12","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m6 6 6 12h-12z","fill":"#272727","transform":"translate(0 -6)"}})])}
var staticRenderFns = []

export { render, staticRenderFns }